import React from 'react'

export const HOSPITAL_PLACEHOLDER_IMAGE =
  'https://scrubstr-wp-uploads.s3.us-east-2.amazonaws.com/2021/01/07212249/hospital-placeholder.png'

export const AGENCY_PLACEHOLDER_IMAGE =
  'https://scrubstr-wp-uploads.s3.us-east-2.amazonaws.com/2021/01/07212249/hospital-placeholder.png'

export const organizationLogoFrameClass =
  'relative shrink-0 overflow-hidden rounded-2xl bg-gradient-to-br from-slate-50 to-gray-100 ring-1 ring-gray-100/80 shadow-sm'

type OrganizationLogoProps = {
  imageUrl?: string | null
  alt?: string
  className?: string
  placeholder?: string
}

export const OrganizationLogo: React.FC<OrganizationLogoProps> = ({
  imageUrl,
  alt = '',
  className = '',
  placeholder = HOSPITAL_PLACEHOLDER_IMAGE,
}) => {
  return (
    <div className={`${organizationLogoFrameClass} ${className}`}>
      <div className="flex size-[4.5rem] items-center justify-center sm:size-24 lg:size-[6.25rem]">
        <img
          className="size-[3.25rem] object-contain p-0.5 sm:size-16 lg:size-[5rem]"
          src={imageUrl || placeholder}
          alt={alt}
        />
      </div>
    </div>
  )
}
